<template>
  <div>
    <div id="login-page" class="form-signin">
      <form action="" v-on:submit.prevent="loggedIn">
        <h3 id="title-login">LOGIN TO JUSTEAT!</h3>
        <div class="form-floating mb-3">
          <input
            type="email"
            class="form-control"
            id="email"
            placeholder="name@example.com"
            v-model="email"
          />
          <label for="floatingInput">Email address</label>
        </div>
        <div class="form-floating mb-3">
          <input
            type="password"
            class="form-control"
            id="password"
            placeholder="Password"
            v-model="password"
          />
          <label for="floatingPassword">Password</label>
        </div>
        <div class="btn">
          <Button
            type="submit"
            class="btn btn-primary"
            buttonText="Login"
          ></Button>
          <!-- <button type="submit" class="btn btn-primary">Login</button> -->
        </div>
      </form>

      <button v-google-signin-button="clientId" class="g-signin2">
        Continue with Google
      </button>

      <p style="color: white">
        Dont have an account?
        <a href="" @click.prevent="toRegister">Register</a>
      </p>
    </div>
  </div>
</template>

<script>
import Button from "../components/button.vue";

export default {
  name: "Login",
  components: {
    Button,
  },
  data() {
    return {
      email: "",
      password: "",
      clientId:
        "983652955158-17kr10pudg1sqhuuuon82qa6rdkkid14.apps.googleusercontent.com",
    };
  },
  methods: {
    loggedIn() {
      const payload = {
        email: this.email,
        password: this.password,
      };
      this.$emit("loginData", payload);
    },
    toRegister() {
      this.$emit("toRegister");
    },
    OnGoogleAuthSuccess(idToken) {
      this.$emit('googleToken', idToken)

    },
    OnGoogleAuthFail(error) {
      console.log(error);
    },
  },
};
</script>

<style>
</style>